import React from "react";
import { Dialog, DialogPanel, Transition } from "@headlessui/react";
import ModalRightCore from "./core/modalRightCore";
export function ModalRight({ open, setOpen, title, children, clickOut = true, maxWidth }) {
    return (<>
            <Transition appear show={open}>
                <Dialog as="div" className="relative z-30" 
    // onClose fires for both Escape and outside-click; clickOut=false instead wraps the overlay in a DialogPanel below.
    onClose={() => setOpen(false)}>
                    {!clickOut ? (<DialogPanel>
                            <ModalRightCore title={title} setOpen={setOpen} children={children} maxWidth={maxWidth}/>
                        </DialogPanel>) : (<ModalRightCore title={title} setOpen={setOpen} children={children} maxWidth={maxWidth}/>)}
                </Dialog>
            </Transition>
        </>);
}
//# sourceMappingURL=modalRight.jsx.map